import { type ToDoItem } from "../ToDoItem";
import storyLines_Framework from "./Framework";

export default class StoryLine {
  className = "???";
  description = () => {
    return "???";
  };

  firstItem?: () => ToDoItem;
  index = -1;

  allStepsAreDone(): boolean {
    if (this.firstItem) {
      let toDoItem: ToDoItem | undefined = this.firstItem();
      if (toDoItem) {
        while (toDoItem && (toDoItem.done() || toDoItem.pattern == undefined)) {
          toDoItem = toDoItem.nextStep ? toDoItem.nextStep() : undefined;
        }

        return !toDoItem || toDoItem.id == storyLines_Framework.select_A().id;
      }
      return false;
    } else {
      return true;
    }
  }
}
